import { useEffect, useContext, memo, useMemo, useRef, } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import { GetAuthorizedPages } from "../../requests";
import './style.css';
import ChangePassword from "../Login/ChangePassword";

import { useGet } from "src/hooks/useGet";
import Header from "src/component/Header";
import OrderReview from "../Doctor/Screens/OrderReview";
import SideBar from "src/component/SideBar";
import { Context } from "src/context";
import Landing from "../Landing";
import RequestMedicine from "../Request";
import ChangeRequest from "../Doctor/Screens/ChangeRequest";
import ManualReceive from "../ManualRecieve/inde";
import DoctorOrder from "../DoctorOrders";
import PharmDropDown from "src/component/PharmDropDown";
import ReturnPrescRequest from "../ReturnPrescRequest";
import { GetRoleId } from "src/utils";
import { ROLES } from "src/common/constants";
import RecurringRequests from "../RecurringRequests";
import WaitingForPacking from "../WaitingForPacking";


const ScreensRouter = () => {

  const { data: authorizedPagesData } = useGet<any>({ API: GetAuthorizedPages, defaultValue: [] })
  const { setAuthorizedPages, isLoggedIn } = useContext(Context)

  const { pathname } = useLocation()

  const isValidToSelectHospital = useMemo(() => pathname != "/" && [ROLES.SUPER_ADMIN, ROLES.PHARMASIST].includes(Number(GetRoleId())), [pathname, isLoggedIn])


  useEffect(() => {
    if (authorizedPagesData?.length)
      setAuthorizedPages(authorizedPagesData)
  }, [authorizedPagesData])

  return (
    <>
      {authorizedPagesData.length > 0 &&
        <>
          <div className="screens-wrapper">
            <SideBar />
            <div className="screens-content">
              <Header />
              <div className="row py-24">
                < div className="col-md-6 col-sm-10 m-auto">  <PharmDropDown /></div>
              </div>
              <Routes>
                <Route >
                  <Route path="/" element={<Landing />} />
                  <Route path="requests" element={<RequestMedicine />} />
                  <Route path="order-review" element={<OrderReview />} />
                  <Route path="change-requests" element={<ChangeRequest />} />
                  <Route path="manual-receive" element={<ManualReceive />} />
                  <Route path="doctor-orders" element={<DoctorOrder />} />
                  <Route path="req-return" element={<ReturnPrescRequest />} />
                  <Route path="recurring-requests" element={<RecurringRequests />} />
                  <Route path="waiting-for-packing" element={<WaitingForPacking />} />
                </Route>
              </Routes>
            </div>
          </div>
        </>
      }
    </>
  );
};

export default memo(ScreensRouter);